import BaseApiService from './BaseApiService'
import type { DemoTemplate, TemplateVariable } from '../types'

class DemoApiService extends BaseApiService {
  templates(): Promise<DemoTemplate[]> {
    return this.post<DemoTemplate[]>('/v1/demo/templates', {})
  }

  variables(templateVersionId: string): Promise<TemplateVariable[]> {
    return this.post<TemplateVariable[]>('/v1/demo/variables', { templateVersionId })
  }

  preview(templateVersionId: string, payload: string, format: 'json' | 'xml' = 'json'): Promise<Blob> {
    return this.postBlob('/v1/demo/preview', { templateVersionId, payload, format })
  }
}

export const demoApiService = new DemoApiService()
